import { LIQUID_OPACITY_MAX, SharedColors } from "apparatus/library/common";
import appStore from "store/store";
export var MultiLiquid;
(function (MultiLiquid) {
    function addLayer(layers) {
        let newLayer;
        if (layers.length > 0) {
            const lastLayer = layers[0];
            newLayer = {
                position: lastLayer.position * 0.66,
                blending: 0,
                alpha: SharedColors.defaultLiquidAlpha,
                color: lastLayer.color.color().rotate(90).hex()
            };
        }
        else {
            newLayer = {
                position: 0.66,
                alpha: SharedColors.defaultLiquidAlpha,
                color: SharedColors.defaultLiquid2,
                blending: 0
            };
        }
        return [newLayer, ...layers];
    }
    MultiLiquid.addLayer = addLayer;
    function createSimpleGradient(color, alpha) {
        return [
            {
                position: 0.1,
                alpha: (alpha + LIQUID_OPACITY_MAX) / 2,
                color: color.color().darken(0.1).round().hex(),
                blending: 1.0
            }
        ];
    }
    MultiLiquid.createSimpleGradient = createSimpleGradient;
    function removeBottomLayer(data) {
        return data.length == 0 ? [] : data.slice(1, data.length);
    }
    MultiLiquid.removeBottomLayer = removeBottomLayer;
    /**
     * @param data Must have length > 0
     * @param topLayerColor Must include alpha and be a string
     */
    function toGradientStops(data, topLayerColor) {
        let stops = [];
        // Precompute all the colours.
        let colors = data.map(d => d.color.color().alpha(d.alpha).toString());
        colors.push(topLayerColor);
        for (var i = 0; i < data.length; i++) {
            stops.push([colors[i], data[i].position]);
            // Depending on blending, place the next stop:
            // blending == 0: No blending: place the stop as close to the current layer as possible
            // blending == 1: Maximum blending, place the stop as close to the next layer.
            const blendUpper = i == data.length - 1 ? 1 : data[i + 1].position;
            const blendRange = blendUpper - data[i].position;
            const blend = data[i].blending;
            stops.push([colors[i + 1], data[i].position + blend * blendRange]);
        }
        stops.push([topLayerColor, 1.0]);
        return stops;
    }
    MultiLiquid.toGradientStops = toGradientStops;
    function adjustNumeric(data, index, key, value) {
        let newData = [...data];
        newData[index] = Object.assign(Object.assign({}, data[index]), { [key]: value });
        if (key == "position") {
            newData.sort((a, b) => a.position - b.position);
        }
        return newData;
    }
    MultiLiquid.adjustNumeric = adjustNumeric;
    function adjustString(data, index, key, value) {
        let newData = [...data];
        if (key == "color") {
            value = value.toLowerCase();
        }
        newData[index] = Object.assign(Object.assign({}, data[index]), { [key]: value });
        return newData;
    }
    MultiLiquid.adjustString = adjustString;
})(MultiLiquid || (MultiLiquid = {}));
export class UpdateLiquidLayers {
    constructor(id, layers, unsafePreviousLayers) {
        this.id = id;
        this.layers = layers;
        // Copy previous layers.
        this.previousLayers = [...unsafePreviousLayers];
    }
    execute() {
        appStore.dispatchFn("updateLiquidLayers", this.mutator(this.layers));
    }
    undo() {
        appStore.dispatchFn("updateLiquidLayers", this.mutator(this.previousLayers));
    }
    mutator(layers) {
        return (store => {
            var newStore = Object.assign({}, store);
            newStore.items = store.items.map(i => i.id === this.id && i.liquid
                ? Object.assign(Object.assign({}, i), { liquid: Object.assign(Object.assign({}, i.liquid), { layers: layers }) }) : i);
            return newStore;
        });
    }
}
